
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) { func.apply(context, args); }
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) { func.apply(context, args); }
	};
}

$.ajaxSetup({
	headers: {
		'X-XSRF-TOKEN': $.cookie('XSRF-TOKEN')
	}
});

/**
 * Trim the value of an input (remove any leading or trailing white space)
 * @param object
 */
function trimInput(object) {
	if (object.value) {
		object.value = object.value.trim();
	}
}

(function () {
	// Initialize any tooltips on the page
	$('[data-toggle="tooltip"]').tooltip();
	// strip any copy and pasted white space from beginning of snumbers
	$('input[name="snumber"], input[name="user[snumber]"]').on('input blur change', function() {
		var el = $(this);
		var currentVal = el.val();
		var newVal = currentVal.trim();
		// only update if the value has actually been changed
		if (currentVal !== newVal) {
			el.val(newVal);
		}
	});

	$('form[data-validate="true"]').validate({
		highlight: function(element) {
			if ($(element).parent('.validation-group').length || $(element).parent('.input-group').length) {
				var parent = $(element).closest('.form-group, .validation-group');
				parent.find('.form-control-success, .form-control-danger').remove();
				parent.append('<span class="form-control-danger"></span>');
			} else {
				$(element).removeClass('form-control-success').addClass('form-control-danger');
			}
			$(element).removeClass('valid').addClass('invalid');

			$(element).closest('.form-group, .validation-group').removeClass('has-success').addClass('has-danger').find('.validation-error-server-side').remove();
		},
		unhighlight: function(element) {
			if ($(element).parent('.validation-group').length || $(element).parent('.input-group').length) {
				var parent = $(element).closest('.form-group, .validation-group');
				parent.find('.form-control-success, .form-control-danger').remove();
				parent.append('<span class="form-control-success"></span>');
			} else {
				$(element).removeClass('form-control-danger').addClass('form-control-success');
			}

			$(element).removeClass('invalid').addClass('valid');

			var group = $(element).closest('.form-group, .validation-group');
			if (!group.find('.invalid,.untouched').length){
				group.removeClass('has-danger').addClass('has-success').find('.validation-error-server-side').remove();
			}

			$('#error_' + element.id).remove();
			if (!$('.form-alerts .global-validation-errors ul li').length){
				$('.form-alerts .global-validation-errors').remove();
			}
		},
		showErrors: function (errorMap, errorList) {

			if (!$('.form-alerts .global-validation-errors').length && errorList.length > 0){
				$('.form-alerts').append(
					'<div class="global-validation-errors alert alert alert-danger alert-dismissible fade in" role="alert">' +
					'<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
					'<strong class="alert-heading">Please check the following</strong>' +
					'<ul></ul></div>'
					);
			}

			var $errorUl = $('.form-alerts .global-validation-errors ul').first();
			$.each(errorList, function(){
				var $el = $(this.element);

				var exists = $errorUl.find('#error_' + this.element.id).first();
				var labelText = typeof $el.data('validation-label') !== 'undefined' ? $el.data('validation-label') : $('label[for=\"' + this.element.id + '"]').text();
				var errorText = '<li id="error_' + this.element.id + '"><a class="input-jump-link" href="#' + this.element.id + '">' + labelText + '</a></li>';

				if (exists.length){
					exists.replaceWith(errorText);
				} else {
					$errorUl.append(errorText);
				}
			});
			this.defaultShowErrors();
		},
		errorElement: 'span',
		errorClass: 'validation-error',
		errorPlacement: function(error, element) {
			if ($(element).parent('.validation-group').length || $(element).parent('.input-group').length) {
				var errors;
				if (!element.parent().next().hasClass('validation-group-errors')){
					element.parent().after('<div class="validation-group-errors"></div>');
				}
				error.appendTo(element.parent().next());
			} else {
				error.insertAfter(element);
			}
		}
	});

	var $validationGroups = $('form .validation-group');
	$validationGroups.find('input, select, textarea').addClass('untouched');
	$validationGroups.on('blur', 'input, select, textarea', function(){
		var $needsValidation = $(this).removeClass('untouched').closest('.validation-group').find('input, select, textarea').not($(this)).not('.untouched');
		if ($needsValidation.length > 0 ){
			$needsValidation.valid();
		}
	});

	$(document).on('click', '.input-jump-link', function(e){
		e.preventDefault();
		var target = $($(e.target).attr('href'));
		target.focus();
		$('html, body').animate({
			scrollTop: target.offset().top
		}, 1000);
		return false;
	});


	$('body').popover({
		container:'body',
		selector:'.snumber-help, .popover-trigger',
		html: true,
		placement: 'top',
		trigger: 'focus',
		constraints:[
			{
				to: 'window',
				attachment: 'together',
				pin:true
			}
		],
		content: function(){
			var selector = $(this).data('content-selector');
			if (selector) {
				return $(selector).html();
			}
		},
		template:'<div class="popover" role="tooltip"><div class="popover-arrow"></div><i class="popover-close kf-close"></i><div class="popover-content"></div></div>'
	});

	//autohide dismissible alerts
	//window.setTimeout(function() {
	//	$(".alert-dismissible").fadeTo(500, 0).slideUp(500, function(){
	//		$(this).remove();
	//	});
	//}, 6000);

	/**
	 * A speedy helper for RESTful linking.
	 *
	 * Add .restful or .ajaxify class to any link, and it will be run as a JSON request.
	 *  - The default href will be used, unless an alternative data-href has been specified.
	 *  - Requests will be treated as a GET, unless a data-method is specified.
	 *  - If a data-modal="foobar" is set, it will look for a modal matching "#foobar". The
	 *    modal should contain an element with data-confirm="modal" which confirms the action and
	 *    fires a request using the origin .resful/.ajaxify link.
	 */
	// A convenience helper for buttons / dialogues, when using AJAX actions against RESTful APIs
	$('a.restful, a.ajaxify').each(function () {
		var el = $(this);

		el.on('click', function (e) {
			// Configure the options for submitting the link via AJAX
			var ajaxOptions = {
				url:    el.data('href') || el.attr('href'),
				method: el.data('method') || 'GET',

				success: function (data, status, jqxhr) {
					if (typeof data.redirect_to !== 'undefined') {
						window.location = data.redirect_to;
					}
				}
			};

			// Check to see if a Modal is present
			var modal = false;
			if (typeof el.data('modal') !== 'undefined') {
				modal = {dialogue: $('#' + el.data('modal')).first()};
				modal.confirm = $(modal.dialogue).find('[data-confirm="modal"]').first();
			}

			// Prevent the default action
			e.preventDefault();

			// Present a modal if configured; will fire AJAX on confirmation
			if (modal && modal.dialogue) {
				(modal.dialogue).modal('show');

				(modal.confirm).on('click', function (e) {
					e.preventDefault();
					$.ajax(ajaxOptions);

					(modal.dialogue).modal('hide');
					(modal.confirm).off('click');
				});
			// Otherwise, just fire the AJAX right away
			} else {
				$.ajax(ajaxOptions);
			}
		});
	});
})();
